import uiRouter from 'angular-ui-router';
import myFoodBenefitComponent from './myFoodBenefit.component';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';
let myFoodBenefitModule = angular.module('food-benefit.myFoodBenefit', [
  uiRouter,
])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider
      .state(STATES.FOOD_BENEFIT.MY_FOOD_BENEFIT, {
        url: ROUTES.FOOD_BENEFIT.MY_FOOD_BENEFIT,
        component: 'myFoodBenefit',
        data: {
          requiresAuth: true,
        },
      });
  })

  .component('myFoodBenefit', myFoodBenefitComponent)

  .name;

export default myFoodBenefitModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/features/myFoodBenefit/myFoodBenefit.js